import { render, staticRenderFns } from "./IntelligentBillResultBy.vue?vue&type=template&id=312ec6a0&"
import script from "./IntelligentBillResultBy.vue?vue&type=script&lang=js&"
export * from "./IntelligentBillResultBy.vue?vue&type=script&lang=js&"
import style0 from "./IntelligentBillResultBy.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('312ec6a0')) {
      api.createRecord('312ec6a0', component.options)
    } else {
      api.reload('312ec6a0', component.options)
    }
    module.hot.accept("./IntelligentBillResultBy.vue?vue&type=template&id=312ec6a0&", function () {
      api.rerender('312ec6a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/ToolAssistant/ocr/IntelligentBillResultBy.vue"
export default component.exports